import React, { type FC } from 'react';

import { Box } from '../box/box';

export interface LoadingIndicatorProps {
  /** Allows the component to get additional styles. */
  className?: string;
}

const LoadingIndicator: FC<LoadingIndicatorProps> = ({ className, ...rest }) => (
  <Box
    {...rest}
    css={theme => ({
      label: 'loadingIndicator',
      margin: 'auto',
      borderStyle: 'solid',
      borderColor: theme.colors.coolGrey[20],
      borderWidth: theme.space.s8,
      borderRadius: '50%',
      width: theme.space.s80,
      height: theme.space.s80,
      borderTopColor: theme.colors.primary,
      animation: `${theme.keyframe.spin} 1s linear infinite`,
      display: 'block',
    })}
    // eslint-disable-next-line @stylistic/jsx-sort-props
    className={className}
    tabIndex={0}
  />
);

export { LoadingIndicator };
export default LoadingIndicator;
